import { render, staticRenderFns } from "./ProductReview.vue?vue&type=template&id=1d6eaa2e&scoped=true"
import script from "./ProductReview.vue?vue&type=script&lang=js"
export * from "./ProductReview.vue?vue&type=script&lang=js"
import style0 from "./ProductReview.vue?vue&type=style&index=0&id=1d6eaa2e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d6eaa2e",
  null
  
)

export default component.exports